import { Heart, Users, Award, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Impact = ({ communityService, achievements }) => {
  return (
    <section id="impact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0D1117] mb-4">
            Social Impact & Leadership
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Making a difference through community service, mentorship, and leadership initiatives
          </p>
        </div>

        {/* Achievements Highlights */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {achievements.map((achievement) => {
            const iconMap = {
              users: Users,
              award: Award,
              certificate: TrendingUp,
              heart: Heart
            };
            const Icon = iconMap[achievement.icon] || Award;
            return (
              <Card key={achievement.id} className="border-none shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 bg-white">
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#9A7B4F]/10 flex items-center justify-center">
                    <Icon className="text-[#9A7B4F]" size={28} />
                  </div>
                  <h4 className="font-bold text-[#0D1117] mb-2">{achievement.title}</h4>
                  <p className="text-sm text-gray-600">{achievement.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Community Service */}
        <div>
          <h3 className="text-2xl font-bold text-[#0D1117] mb-8 flex items-center gap-3">
            <Heart className="text-[#9A7B4F]" size={28} />
            Community Service & Volunteering
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {communityService.map((service) => (
              <Card key={service.id} className="border-none shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 bg-white">
                <CardContent className="p-6">
                  <div className="mb-4">
                    <h4 className="text-xl font-bold text-[#0D1117] mb-2">{service.organization}</h4>
                    <p className="text-[#9A7B4F] font-semibold text-sm mb-1">{service.role}</p>
                    <p className="text-xs text-gray-600">{service.duration}</p>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;